import React, { useState, useContext, useEffect } from "react";
import { Row, Col, Form, Table, Button } from "react-bootstrap";
import moment from "moment";
import helpers from "../../utils/helpers";
import obj, { formatNumber, headerData } from "../../utils/constants";
import transparentGif from "../../assets/images/transparent.gif";
import { toast } from "wc-toast";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import ReactPaginate from "react-paginate";
import AuthContext from "../../context/AuthContext";
import Loader from "../../assets/gif/loader.gif";
import { capitalize, isEmpty, startCase } from "lodash";
import PaginationComp from "../../components/PaginationComp";
import DatePicker from "react-datepicker";
const ProfitLossHistory = ({
  title,
  filter,
  setFilter,
  data,
  getData,
  betType,
  viewpage,
  handlePageClick,
  pageCount,
  total,
  setInnertab,
  innertab,
  total2,
  dataOld,
}) => {
  const showDetail = (event, id) => {
    const detailDiv = document.getElementById(id);
    if (detailDiv) {
      if (detailDiv.style.display === "none") {
        detailDiv.style.setProperty("display", "contents");
        event.target.className = "fas fa-minus-square pe-2";
      } else {
        detailDiv.style.setProperty("display", "none");
        event.target.className = "fas fa-plus-square pe-2";
      }
    }
  };
  let { loginUserDetailData } = useContext(AuthContext);
  const [getProperty, setProperty] = useState("none");
  const showDetail1 = (event, id) => {
    const detailDiv = document.getElementById(id);

    if (detailDiv.style.display === "none") {
      detailDiv.style.setProperty("display", "contents");
      event.target.className = "fas fa-minus-square pe-2";
    } else {
      detailDiv.style.setProperty("display", "none");
      event.target.className = "fas fa-plus-square pe-2";
    }
  };
  const redirectCasino = async (userId, platform, platformTxId, type) => {
    const { status, data: response_users } = await apiGet(
      apiPath.casinoWalletHistory +
        "?userId=" +
        userId +
        "&platform=" +
        platform +
        "&platformTxId=" +
        platformTxId
    );
    //console.log(response_users, status);
    if (status === 200) {
      if (response_users.status) {
        if (response_users.data?.status === "0000") {
          if (type === 1) {
            javascript: window.open(
              response_users.data?.txnUrl,
              "_blank",
              "height=900,width=1200"
            );
          } else {
            javascript: window.open(
              response_users.data?.url,
              "_blank",
              "height=900,width=1200"
            );
          }
        } else {
          toast.error(response_users.data.desc);
        }
      } else {
        toast.error(response_users.data.desc);
      }
    } else {
      toast.error(response_users.data.desc);
    }
  };
  const [active, setActive] = useState([]);

  return (
    <div className="common-container">
      <div className="bg-white p-2 pt-0">
        <Form className="bet_status mb-1">
          <Row>
            <Col xl={11} md={12}>
              <Row>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="d-flex align-items-center betting-time-zone">
                    <Form.Label className="pe-3">Period</Form.Label>
                    <div className="d-flex align-items-center">
                    <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.fromPeriod
                                    ? new Date(filter.fromPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: date
                                      .toISOString()
                                      .split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                      <Form.Control
                        className="small_form_control"
                        type="text"
                        placeholder="09:00"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center betting-time-zone">
                    <Form.Label className="pe-3">to</Form.Label>

                    <div className="d-flex align-items-center">
                    <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.toPeriod
                                    ? new Date(filter.toPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: date.toISOString().split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                minDate={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                maxDate={new Date().toISOString().split("T")[0]}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                      <Form.Control
                        className="small_form_control"
                        type="text"
                        placeholder="08:59"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </Row>
              <div className="input-list-data">
                <ul className="input-list">
                  <li>
                    <a
                      onClick={(e) =>
                        setFilter({
                          ...filter,
                          filterByDay: "today",
                        })
                      }
                      style={{
                        // background:
                        //   filter.filterByDay === "today" ? "green" : "",
                        cursor: "pointer",
                      }}
                    >
                      Just For Today
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={(e) =>
                        setFilter({
                          ...filter,
                          filterByDay: "yesterday",
                        })
                      }
                      style={{
                        // background:
                        //   filter.filterByDay === "yesterday" ? "green" : "",
                        cursor: "pointer",
                      }}
                    >
                      From Yesterday
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={getData}
                      style={{ cursor: "pointer" }}
                      className="btn-send"
                    >
                      Get P & L
                    </a>
                  </li>
                  {/* <li>
                  <a
                    onClick={() => {
                      setFilter({
                        betType:
                          title === "Exchange"
                            ? "betfair"
                            : title === "FancyBet"
                            ? "fancy"
                            : title === "Fancy1Bet"
                            ? "sportBook"
                            : title === "BookMaker"
                            ? "bookmaker"
                            : title === "Tie"
                            ? "tie"
                            : title === "Toss"
                            ? "toss"
                            : "casino",
                        status: "",
                        toPeriod: "",
                        fromPeriod: "",
                        filterByDay: "",
                      });
                      getData("reset");
                    }}
                    className="btn-send"
                    style={{ cursor: "pointer" }}
                  >
                    Reset
                  </a>
                </li> */}
                </ul>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      {dataOld?.data?.length == 0 || isEmpty(dataOld) ? (
        <div id="noReportMessage" className="bg-white p-2">
          <p>
            Betting History enables you to review the bets you have placed.{" "}
            <br />
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </p>
          <p>Betting History is available online for the past 62 days.</p>
          <p>User can search up to 14 days records per query only .</p>
        </div>
      ) : (
        <>
          <section className="account-table my-bet-sec">
            <div className="profile-tab">
              <div className="my_account_table_wrap">
                <div className="table-main-wrapper">
                  <div id="report" data-report="profitAndLossReport">
                    <ul id="spotsUl" className="total-show mt-2">
                      <li id="totalPL">
                        Total P/L: PHK
                        <span
                          style={{ marginLeft: "3px" }}
                          className={total > 0 ? "" : "red"}
                        >
                          {total > 0
                            ? helpers.currencyFormat(total)
                            : `(${helpers.currencyFormat(
                                Math.abs(total.toFixed(2))
                              )})`}{" "}
                        </span>
                      </li>

                      {title !== "casino" && (
                        <>
                          <li id="sumOfQuery" className="sports-switch">
                            PHK{" "}
                            <span
                              style={{ marginLeft: "3px" }}
                              className={total2 > 0 ? "" : "red"}
                            >
                              {total2 > 0
                                ? helpers.currencyFormat(total2)
                                : `(${helpers.currencyFormat(
                                    Math.abs(total2.toFixed(2))
                                  )})`}{" "}
                            </span>
                          </li>
                          <li className="sports-switch">
                            <select
                              onChange={(e) => {
                                setInnertab(e.target.value);
                              }}
                              value={innertab}
                            >
                              <option value="all">ALL</option>
                              <option value="4">CRICKET</option>{" "}
                              <option value="2">TENNIS</option>{" "}
                              <option value="1">SOCCER</option>
                            </select>
                          </li>{" "}
                        </>
                      )}
                    </ul>

                    <div className="profit_loss_table">
                      {title === "casino" ? (
                        <table
                          id="reportTable"
                          className="table01 table-pnl"
                          style={{ display: `table` }}
                        >
                          <tbody>
                            <tr>
                              <th scope="col" style={{ textAlign: "left" }}>
                                Market
                              </th>
                              <th scope="col" style={{ textAlign: "right" }}>
                                Profit / Loss
                              </th>
                            </tr>

                            {data?.data && data?.data?.length > 0 ? (
                              data?.data?.map((item, index) => {
                                return (
                                  <>
                                    <tr
                                      id="summary0"
                                      style={{ display: "table-row" }}
                                      key={index + 1}
                                    >
                                      <td id="title" className="">
                                        Casino
                                        {/* <span className="angle_unicode">▸</span> */}
                                        <img
                                          class="fromto"
                                          src={require("../../assets/images/transparent.gif")}
                                        />
                                        <strong> {item?.casinoName}</strong>
                                        {/* <span className="angle_unicode">▸</span> */}
                                        <img
                                          class="fromto"
                                          src={require("../../assets/images/transparent.gif")}
                                        />
                                        {moment(item?.timeInserted).format(
                                          "YYYY-MM-DD hh:mm:ss"
                                        )}
                                      </td>
                                      <td>
                                        {Math.sign(item?.playerPL) === -1 ? (
                                          <span className="text-danger">
                                            (
                                            {helpers.currencyFormat(
                                              Math.abs(item?.playerPL.toFixed(2))
                                            )}
                                            )
                                          </span>
                                        ) : (
                                          <span className="">
                                            {helpers.currencyFormat(
                                              Math.abs(item?.playerPL.toFixed(2))
                                            )}
                                          </span>
                                        )}

                                        <span
                                          style={{
                                            color: "#2789ce",
                                            marginLeft: "4px",
                                          }}
                                        >
                                          {active.includes(item?._id) ? (
                                            <img
                                              style={{
                                                height: "15px",
                                                marginRight: "5px",
                                              }}
                                              onClick={() =>
                                                setActive((prev) => {
                                                  return prev?.filter((res) => {
                                                    return res !== item?._id;
                                                  });
                                                })
                                              }
                                              src={require("../../assets/images/expand-open.png")}
                                            />
                                          ) : (
                                            <img
                                              style={{
                                                height: "15px",
                                                marginRight: "5px",
                                              }}
                                              onClick={() =>
                                                setActive((prev) => {
                                                  return [...prev, item?._id];
                                                })
                                              }
                                              src={require("../../assets/images/expand-close.png")}
                                            />
                                          )}{" "}
                                        </span>
                                        {/* <i
                                        id={"icon_" + item?.platformTxId}
                                        class="fas fa-plus-square"
                                        onClick={(e) =>
                                          showDetail1(e, item?.platformTxId)
                                        }
                                      ></i> */}
                                      </td>
                                    </tr>

                                    {active?.includes(item?._id) && (
                                      <tr
                                        className="expand"
                                        id={item?._id}
                                        // style={{ display: getProperty }}
                                        key={item?._id}
                                      >
                                        <td
                                          colSpan="4"
                                          style={{ position: "relative" }}
                                          className="expand_wrap"
                                        >
                                          <table className="table-commission">
                                            <tbody>
                                              <tr>
                                                <th
                                                  style={{ textAlign: "left" }}
                                                >
                                                  Platform
                                                </th>
                                                <th>Valid Turnover</th>
                                                <th>Win/Loss</th>
                                                <th>PT/Comm.</th>
                                                <th>Profit / Loss</th>
                                                <th>Action</th>
                                              </tr>
                                              <tr
                                                id="txRow0"
                                                style={{
                                                  display: "table-row",
                                                }}
                                                className="even"
                                                // key={i + 1}
                                              >
                                                <td id="betID">
                                                  <Button
                                                    style={{
                                                      fontSize: "10px",
                                                      padding: "4px",
                                                    }}
                                                    className="theme_dark_btn"
                                                    onClick={() =>
                                                      redirectCasino(
                                                        item?.clientName,
                                                        item?.platform,
                                                        item?.platformTxId,
                                                        1
                                                      )
                                                    }
                                                  >
                                                    {item.platform}
                                                  </Button>
                                                </td>
                                                <td>0.00</td>
                                                <td>
                                                  {" "}
                                                  {Math.sign(item?.playerPL) ===
                                                  -1 ? (
                                                    <span className="text-danger">
                                                      (
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                      )
                                                    </span>
                                                  ) : (
                                                    <span className="">
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                    </span>
                                                  )}
                                                </td>
                                                <td>0.00</td>
                                                <td>
                                                  {" "}
                                                  {Math.sign(item?.playerPL) ===
                                                  -1 ? (
                                                    <span className="text-danger">
                                                      (
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                      )
                                                    </span>
                                                  ) : (
                                                    <span className="">
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                    </span>
                                                  )}
                                                </td>
                                                <td>
                                                  <Button
                                                    style={{
                                                      fontSize: "10px",
                                                      padding: "4px",
                                                    }}
                                                    className="theme_dark_btn"
                                                    onClick={() =>
                                                      redirectCasino(
                                                        item?.clientName,
                                                        item?.platform,
                                                        item?.platformTxId,
                                                        2
                                                      )
                                                    }
                                                  >
                                                    Result
                                                  </Button>
                                                </td>
                                              </tr>
                                              <tr class="casino-grand-total">
                                                <td>Grand Total</td>
                                                <td id="totalTurnover">0.00</td>
                                                <td id="totalPayout">
                                                  {Math.sign(item?.playerPL) ===
                                                  -1 ? (
                                                    <span className="text-danger">
                                                      (
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                      )
                                                    </span>
                                                  ) : (
                                                    <span className="">
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                    </span>
                                                  )}
                                                </td>
                                                <td id="totalTaxRebate">
                                                  0.00
                                                </td>
                                                <td id="totalBalance">
                                                  {Math.sign(item?.playerPL) ===
                                                  -1 ? (
                                                    <span className="text-danger">
                                                      (
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                      )
                                                    </span>
                                                  ) : (
                                                    <span className="">
                                                      {helpers.currencyFormat(
                                                        Math.abs(item?.playerPL.toFixed(2))
                                                      )}
                                                    </span>
                                                  )}
                                                </td>
                                                <td></td>
                                              </tr>
                                            </tbody>
                                          </table>{" "}
                                          <img
                                            class="expand-arrow-R"
                                            src={require("../../assets/images/transparent.gif")}
                                          ></img>
                                        </td>
                                      </tr>
                                    )}
                                  </>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={10}>
                                  <span>
                                    You have no bets in this time period.
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      ) : title == "parlay" ? (
                        <Table>
                          <thead>
                            <tr>
                              <th scope="col" className="text-start">
                                Market
                              </th>
                              <th scope="col" className="text-end">
                                {" "}
                                Settled Date
                              </th>
                              <th scope="col" className="text-end">
                                {" "}
                                Bet ID
                              </th>
                              <th scope="col" className="text-end">
                                Stake
                              </th>
                              <th scope="col" className="text-end">
                                Profit / Loss
                              </th>
                            </tr>
                          </thead>

                          {data?.data?.length > 0 ? (
                            data?.data?.map((item, index) => {
                              return (
                                <>
                                  <tr
                                    id="summary0"
                                    style={{ display: "table-row" }}
                                    key={index + 1}
                                  >
                                    <td className="text-start">
                                      {item?.isDeclared ? (
                                        <>
                                          {item?.result == "loss" ? (
                                            <strong
                                              // className="d-block"
                                              style={{ color: "red" }}
                                            >
                                              {startCase(item?.result)}
                                            </strong>
                                          ) : (
                                            <strong
                                              // className="d-block"
                                              style={{ color: "green" }}
                                            >
                                              {startCase(item?.result)}
                                            </strong>
                                          )}
                                        </>
                                      ) : (
                                        "..."
                                      )}
                                      <span className="angle_unicode">▸</span>
                                      <strong>
                                        {item?.bets?.length == 0
                                          ? ""
                                          : item?.bets?.length == 1
                                          ? "SINGLE"
                                          : item?.bets?.length == 2
                                          ? "DOUBLE"
                                          : item?.bets?.length == 3
                                          ? "TREBLE"
                                          : "ACCMULATOR"}
                                      </strong>
                                    </td>

                                    <td id="settledDate">
                                      {" "}
                                      {helpers.dateFormat(item.timeInserted)}
                                    </td>

                                    <td id="settledDate" className="text-end">
                                      {" "}
                                      {item?.matchBetId}
                                    </td>
                                    <td id="settledDate"> {item?.amount}</td>
                                    <td>
                                      <a
                                        id="pl0"
                                        className="expand-open"
                                        href="javascript:void(0)"
                                      >
                                        {item?.isDeclared ? (
                                          <>
                                            {item?.result == "loss" ? (
                                              <strong style={{ color: "red" }}>
                                                {helpers.currencyFormat(
                                                  item?.loseAmount.toFixed(2)
                                                )}
                                              </strong>
                                            ) : (
                                              <strong
                                                style={{ color: "green" }}
                                              >
                                                {helpers.currencyFormat(
                                                  item?.profitAmount.toFixed(2)
                                                )}
                                              </strong>
                                            )}
                                          </>
                                        ) : (
                                          "..."
                                        )}
                                      </a>
                                      <i
                                        id={"icon_" + item?._id}
                                        className="fas fa-plus-square"
                                        onClick={(e) =>
                                          showDetail(e, item?._id)
                                        }
                                      ></i>
                                    </td>
                                  </tr>
                                  {item?.bets?.length > 0 && (
                                    <tr
                                      className="expand"
                                      id={item?._id}
                                      style={{ display: getProperty }}
                                      key={item?._id}
                                    >
                                      <td colSpan="6" className="expand_wrap">
                                        <table className="table-commission">
                                          <tbody>
                                            <tr>
                                              {/* <th>User Name</th> */}
                                              <th className="text-start">
                                                Fancy Name
                                              </th>
                                              <th className="text-end">
                                                Selection
                                              </th>
                                              <th className="text-end">Odds</th>
                                              {/* <th>Stake</th> */}
                                              {/* <th>Type</th> */}
                                              <th className="text-end">
                                                Profit/Loss
                                              </th>
                                            </tr>
                                            {item?.bets?.map((betData, i) => {
                                              return (
                                                <tr
                                                  id="txRow0"
                                                  style={{
                                                    display: "table-row",
                                                  }}
                                                  className="even"
                                                  key={i + 1}
                                                >
                                                  {/* <td id="betID">
                                                    {betData?.clientName}
                                                  </td> */}
                                                  <td id="betID">
                                                    {`${betData?.matchName}  ->  ${betData?.fancyName}`}
                                                  </td>
                                                  <td id="matchSelection">
                                                    {betData?.runnerName}
                                                  </td>
                                                  <td id="txOddsMatched">
                                                    {betData?.bhav}
                                                  </td>
                                                  {/* <td id="txStake">
                                                    {" "}
                                                    {betData?.amount}
                                                  </td>
                                                  <td>
                                                    <span
                                                      id="matchType"
                                                      className={
                                                        betData?.betType ===
                                                        "lay"
                                                          ? "lay"
                                                          : "back"
                                                      }
                                                    >
                                                      {betData?.betType}
                                                    </span>
                                                  </td> */}
                                                  <td id="placed">
                                                    {" "}
                                                    {/* {Number(
                                                      betData?.result == "win"
                                                        ? betData?.profitAmount
                                                        : betData?.loseAmount
                                                    )?.toFixed(2)} */}
                                                    {betData?.isDeclared ? (
                                                      <>
                                                        {betData?.result ==
                                                        "loss" ? (
                                                          <strong
                                                            style={{
                                                              color: "red",
                                                            }}
                                                          >
                                                            {startCase(
                                                              betData?.result
                                                            )}
                                                          </strong>
                                                        ) : (
                                                          <strong
                                                            style={{
                                                              color: "green",
                                                            }}
                                                          >
                                                            {startCase(
                                                              betData?.result
                                                            )}
                                                          </strong>
                                                        )}
                                                      </>
                                                    ) : (
                                                      "..."
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                            <tr className="sum-pl">
                                              <td colSpan="8">
                                                <dl>
                                                  <dt>Net Market Total</dt>
                                                  <dd id="totalStakes">
                                                    {item?.isDeclared ? (
                                                      <>
                                                        {item?.result ==
                                                        "loss" ? (
                                                          <strong
                                                            style={{
                                                              color: "red",
                                                            }}
                                                          >
                                                            {Number(
                                                              item?.loseAmount
                                                            )?.toFixed(2)}
                                                          </strong>
                                                        ) : (
                                                          <strong
                                                            style={{
                                                              color: "green",
                                                            }}
                                                          >
                                                            {Number(
                                                              item?.profitAmount
                                                            )?.toFixed(2)}
                                                          </strong>
                                                        )}
                                                      </>
                                                    ) : (
                                                      "..."
                                                    )}
                                                  </dd>
                                                </dl>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={10}>
                                <span>
                                  You have no bets in this time period.
                                </span>
                              </td>
                            </tr>
                          )}
                        </Table>
                      ) : (
                        <table
                          id="reportTable"
                          className="table01 table-pnl"
                          style={{ display: `table` }}
                        >
                          <tbody>
                            <tr>
                              <th width="" className="align-L">
                                Market
                              </th>
                              <th width="15%">Start Time</th>
                              <th width="15%">Settled date</th>
                              <th width="18%">Profit/Loss</th>
                            </tr>
                            {data?.data && data?.data?.length > 0 ? (
                              data?.data?.map((item, index) => {
                                const resultTotalStake =
                                  item?.bets_list?.reduce((a, v) => {
                                    a = parseFloat(a) + parseFloat(v.amount);
                                    return a;
                                  }, 0);
                                const backTotalProfitAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.betType === "back" &&
                                      v?.teamSelectionWin === v?.selectionId
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.profitAmount);
                                    }

                                    return a;
                                  }, 0);

                                const backTotalLoseAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.betType === "back" &&
                                      v?.teamSelectionWin !== v?.selectionId
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.loseAmount);
                                    }
                                    return a;
                                  }, 0);

                                let backSubTotalresult =
                                  backTotalProfitAmount > backTotalLoseAmount
                                    ? (backTotalProfitAmount -
                                      backTotalLoseAmount)
                                    : -(
                                        backTotalLoseAmount -
                                        backTotalProfitAmount
                                      );

                                const layTotalProfitAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.betType === "lay" &&
                                      v?.teamSelectionWin !== v?.selectionId
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.profitAmount);
                                    }
                                    return a;
                                  }, 0);

                                const layTotalLoseAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.betType === "lay" &&
                                      v?.teamSelectionWin === v?.selectionId
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.loseAmount);
                                    }
                                    return a;
                                  }, 0);

                                let laySubTotalresult =
                                  layTotalProfitAmount > layTotalLoseAmount
                                    ? layTotalProfitAmount - layTotalLoseAmount
                                    : -(
                                        layTotalLoseAmount -
                                        layTotalProfitAmount
                                      );
                                let marketSubTotal =
                                  backSubTotalresult + laySubTotalresult;
                                const yesTotalProfitAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.type == "Yes" &&
                                      v?.decisionRun >= v?.betRun
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.profitAmount);
                                    }
                                    return a;
                                  }, 0);

                                const yesTotalLoseAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.type == "Yes" &&
                                      v?.decisionRun < v?.betRun
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.loseAmount);
                                    }
                                    return a;
                                  }, 0);

                                let yesSubTotalresult =
                                  yesTotalProfitAmount > yesTotalLoseAmount
                                    ? yesTotalProfitAmount - yesTotalLoseAmount
                                    : -(
                                        yesTotalLoseAmount -
                                        yesTotalProfitAmount
                                      );

                                const noTotalProfitAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.type == "No" &&
                                      v?.decisionRun < v?.betRun
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.profitAmount);
                                    }
                                    return a;
                                  }, 0);
                                const noTotalLoseAmount =
                                  item?.bets_list?.reduce((a, v) => {
                                    if (
                                      v?.type == "No" &&
                                      v?.decisionRun >= v?.betRun
                                    ) {
                                      a =
                                        parseFloat(a) +
                                        parseFloat(v.loseAmount);
                                    }
                                    return a;
                                  }, 0);
                                let noSubTotalresult =
                                  noTotalProfitAmount > noTotalLoseAmount
                                    ? noTotalProfitAmount - noTotalLoseAmount
                                    : -(
                                        noTotalLoseAmount - noTotalProfitAmount
                                      );

                              

                                let fancyMarketSubTotal =
                                  yesSubTotalresult + noSubTotalresult;

                                let fancyNetAmount = fancyMarketSubTotal;

                                let v =
                                  marketSubTotal > 0
                                    ? (marketSubTotal *
                                        loginUserDetailData?.commission) /
                                      100
                                    : "";
                                    let netAmount = 0;
                              
                  
                                if (betType == "toss" || betType == "tie") {
                                  netAmount = marketSubTotal;
                                }  else if (betType == "fancy") {
                                  netAmount = fancyNetAmount;
                                } else {
                                  netAmount = marketSubTotal - v;
                                }
                     

                                return item?.bets_list?.length>0 &&(
                                  
                                  <>
                                    <tr
                                      id="summary0"
                                      style={{ display: "table-row" }}
                                      key={index + 1}
                                    >
                                      <td className="text-start">
                                        <span
                                          style={{ textTransform: "uppercase" }}
                                        >
                                          {obj.betCheckObj[item?.eventType]}
                                        </span>
                                        <img
                                          class="fromto"
                                          src={require("../../assets/images/transparent.gif")}
                                        />
                                        <strong>
                                          {betType === "casino"
                                            ? item?.casinoName
                                            : item?.matchName
                                            ? item?.matchName
                                            : item?.eventName}
                                        </strong>
                                        <img
                                          class="fromto"
                                          src={require("../../assets/images/transparent.gif")}
                                        />
                                        {betType == "betfair" && item?.market}
                                        {betType === "sportBook" && "SportBook"}
                                        {betType === "fancy" && "Fancy"}{" "}
                                        {betType === "casino" &&
                                          item?.casinoType}{" "}
                                        {betType === "toss" && "Toss"}{" "}
                                        {betType === "bookmaker" && "Bookmaker"}{" "}
                                      </td>
                                      <td id="startTime">
                                        {" "}
                                        {moment(item?.eventDateTime).format(
                                          "YYYY-MM-DD hh:mm:ss"
                                        )}
                                      </td>
                                      <td id="settledDate">
                                        {" "}
                                        {moment(item?.updatedAt).format(
                                          "YYYY-MM-DD hh:mm:ss"
                                        )}
                                      </td>
                                      <td className="text-end">
                                        <a
                                          id="pl0"
                                          className="expand-open"
                                           href="javascript:void(0)"
                                          style={{
                                            textDecoration: "none",
                                            paddingRight: "0",
                                          }}
                                        >
                                          {betType == "fancy" ? (
                                            fancyNetAmount > 0 ? (
                                              helpers.currencyFormat(
                                                Math.abs(fancyNetAmount.toFixed(2))
                                              )
                                            ) : (
                                              <span className="red">
                                                (
                                                {helpers.currencyFormat(
                                                  Math.abs(fancyNetAmount.toFixed(2))
                                                )}
                                                )
                                              </span>
                                            )
                                          ) : netAmount > 0 ? (
                                            helpers.currencyFormat(netAmount.toFixed(2))
                                          ) : (
                                            <span className="red">
                                              (
                                              {helpers.currencyFormat(
                                                Math.abs(netAmount.toFixed(2))
                                              )}
                                              )
                                            </span>
                                          )}{" "}
                                          <span
                                            style={{
                                              color: "#2789ce",
                                            }}
                                          >
                                            {active.includes(item?._id) ? (
                                              <img
                                                style={{
                                                  height: "15px",
                                                  marginRight: "5px",
                                                }}
                                                onClick={() =>
                                                  setActive((prev) => {
                                                    return prev?.filter(
                                                      (res) => {
                                                        return (
                                                          res !== item?._id
                                                        );
                                                      }
                                                    );
                                                  })
                                                }
                                                src={require("../../assets/images/expand-open.png")}
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  height: "15px",
                                                  marginRight: "5px",
                                                }}
                                                onClick={() =>
                                                  setActive((prev) => {
                                                    return [...prev, item?._id];
                                                  })
                                                }
                                                src={require("../../assets/images/expand-close.png")}
                                              />
                                            )}{" "}
                                            {item?.matchBetId ||
                                              item?.sessionBetId}
                                          </span>
                                        </a>
                                        {/* <i
                                          id={"icon_" + item?._id}
                                          className="fas fa-plus-square"
                                          onClick={(e) =>
                                            showDetail(e, item?._id)
                                          }
                                        ></i> */}
                                      </td>
                                    </tr>
                                    {item?.bets_list?.length > 0 &&
                                      active?.includes(item?._id) && (
                                        <tr
                                          className="expand"
                                          id={item?._id}
                                          // style={{ display: getProperty }}
                                          key={item?._id}
                                        >
                                          <td
                                            colSpan="4"
                                            style={{ position: "relative" }}
                                            className="expand_wrap"
                                          >
                                            <table className="table-commission">
                                              <tbody>
                                                <tr>
                                                  <th width="9%">Bet ID</th>
                                                  <th width="">Selection</th>
                                                  <th width="9%">Odds</th>
                                                  <th width="13%">Stake</th>
                                                  <th width="8%">Type</th>
                                                  <th width="16%">Placed</th>
                                                  <th width="23%">
                                                    Profit/Loss
                                                  </th>
                                                </tr>
                                                {item?.bets_list?.map(
                                                  (betData, i) => {
                                                    return (
                                                      <tr
                                                        id="txRow0"
                                                        style={{
                                                          display: "table-row",
                                                        }}
                                                        className="even"
                                                        key={i + 1}
                                                      >
                                                        <td id="betID">
                                                          {betType == "fancy"
                                                            ? betData?.sessionBetId
                                                            : betData?.matchBetId}
                                                        </td>
                                                        <td id="matchSelection">
                                                          {betType == "fancy" ||
                                                          betType ==
                                                            "sportBook" ? (
                                                            betType ==
                                                            "sportBook" ? (
                                                              <>
                                                                {
                                                                  betData?.fancyName
                                                                }{" "}
                                                                <img
                                                                  class="fromto"
                                                                  src={require("../../assets/images/transparent.gif")}
                                                                />
                                                                {
                                                                  betData?.runnerName
                                                                }{" "}
                                                              </>
                                                            ) : (
                                                              betData?.fancyName
                                                            )
                                                          ) : (
                                                            betData?.teamName
                                                          )}
                                                        </td>
                                                        <td id="txOddsMatched">
                                                          {betType == "fancy"
                                                            ? betData?.betRun +
                                                              "/" +
                                                              betData?.bhav
                                                            : betData?.bhav}

                                                          {}
                                                        </td>
                                                        <td id="txStake">
                                                          {" "}
                                                          {betData?.amount.toFixed(2)}
                                                        </td>
                                                        <td>
                                                          {betType ==
                                                          "fancy" ? (
                                                            <span
                                                              id="matchType"
                                                              className={
                                                                betData?.type ===
                                                                "No"
                                                                  ? "lay"
                                                                  : "back"
                                                              }
                                                            >
                                                              {capitalize(
                                                                betData?.type
                                                              )}
                                                            </span>
                                                          ) : (
                                                            <span
                                                              id="matchType"
                                                              className={
                                                                betData?.betType ===
                                                                "lay"
                                                                  ? "lay"
                                                                  : "back"
                                                              }
                                                            >
                                                              {capitalize(
                                                                betData?.betType
                                                              )}
                                                            </span>
                                                          )}
                                                        </td>
                                                        <td id="placed">
                                                          {moment(
                                                            betData?.createdAt
                                                          ).format(
                                                            "YYYY-MM-DD hh:mm:ss"
                                                          )}
                                                        </td>
                                                        {betType == "fancy" ? (
                                                          <td id="txLiability">
                                                            {betData?.type ==
                                                            "No" ? (
                                                              betData?.decisionRun <
                                                              betData?.betRun ? (
                                                                <span>
                                                                  {helpers.currencyFormat(
                                                                    Math.abs(
                                                                      betData?.profitAmount.toFixed(2)
                                                                    )
                                                                  )}
                                                                </span>
                                                              ) : (
                                                                <span className="red">
                                                                  (
                                                                  {helpers.currencyFormat(
                                                                    Math.abs(
                                                                      betData?.loseAmount.toFixed(2)
                                                                    )
                                                                  )}
                                                                  )
                                                                </span>
                                                              )
                                                            ) : betData?.decisionRun >=
                                                              betData?.betRun ? (
                                                              <span>
                                                                {helpers.currencyFormat(
                                                                  Math.abs(
                                                                    betData?.profitAmount.toFixed(2)
                                                                  )
                                                                )}
                                                              </span>
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers.currencyFormat(
                                                                  Math.abs(
                                                                    betData?.loseAmount.toFixed(2)
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )}
                                                          </td>
                                                        ) : (betData?.teamSelectionWin ==
                                                            betData?.selectionId &&
                                                            betData?.betType ==
                                                              "back") ||
                                                          (betData?.teamSelectionWin !=
                                                            betData?.selectionId &&
                                                            betData?.betType ==
                                                              "lay") ? (
                                                          <td id="txLiability">
                                                            {helpers.currencyFormat(
                                                              Math.abs(
                                                                betData?.profitAmount.toFixed(2)
                                                              )
                                                            )}
                                                          </td>
                                                        ) : (
                                                          <td id="txLiability">
                                                            <span className="red">
                                                              (
                                                              {helpers.currencyFormat(
                                                                Math.abs(
                                                                  betData?.loseAmount.toFixed(2)
                                                                )
                                                              )}
                                                              )
                                                            </span>
                                                          </td>
                                                        )}
                                                      </tr>
                                                    );
                                                  }
                                                )}

                                                <tr className="sum-pl">
                                                  <td colSpan="7">
                                                    <dl
                                                      style={{
                                                        marginBottom: "0",
                                                      }}
                                                    >
                                                      <dt>Total Stakes</dt>
                                                      <dd id="totalStakes">
                                                        {helpers.currencyFormat(
                                                          Math.abs(
                                                            resultTotalStake
                                                          )
                                                        )}
                                                      </dd>
                                                      {betType == "fancy" ? (
                                                        <>
                                                          <dt id="backSubTotalTitle">
                                                            Yes subtotal
                                                          </dt>
                                                          <dd id="backSubTotal">
                                                            {" "}
                                                            {yesSubTotalresult ? (
                                                              yesTotalProfitAmount >
                                                              yesTotalLoseAmount ? (
                                                                helpers.currencyFormat(
                                                                  Math.abs(
                                                                    yesSubTotalresult.toFixed(2)
                                                                  )
                                                                )
                                                              ) : (
                                                                <span className="red">
                                                                  (
                                                                  {helpers.currencyFormat(
                                                                    Math.abs(
                                                                      yesSubTotalresult.toFixed(2)
                                                                    )
                                                                  )}
                                                                  )
                                                                </span>
                                                              )
                                                            ) : (
                                                              helpers.currencyFormat(
                                                                Math.abs(
                                                                  yesSubTotalresult.toFixed(2)
                                                                )
                                                              )
                                                            )}
                                                          </dd>

                                                          <dt id="laySubTotalTitle">
                                                            No subtotal
                                                          </dt>
                                                          <dd id="laySubTotal">
                                                            {noSubTotalresult ? (
                                                              noTotalProfitAmount >
                                                              noTotalLoseAmount ? (
                                                                helpers.currencyFormat(
                                                                  Math.abs(
                                                                    noSubTotalresult.toFixed(2)
                                                                  )
                                                                )
                                                              ) : (
                                                                <span className="red">
                                                                  (
                                                                  {helpers.currencyFormat(
                                                                    Math.abs(
                                                                      noSubTotalresult.toFixed(2)
                                                                    )
                                                                  )}
                                                                  )
                                                                </span>
                                                              )
                                                            ) : (
                                                              helpers.currencyFormat(
                                                                Math.abs(
                                                                  noSubTotalresult.toFixed(2)
                                                                )
                                                              )
                                                            )}
                                                          </dd>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <dt id="backSubTotalTitle">
                                                            Back subtotal
                                                          </dt>
                                                          <dd id="backSubTotal">
                                                            {" "}
                                                            {backSubTotalresult ? (
                                                              backTotalProfitAmount >
                                                              backTotalLoseAmount ? (
                                                                helpers.currencyFormat(
                                                                  Math.abs(
                                                                    backSubTotalresult.toFixed(2)
                                                                  )
                                                                )
                                                              ) : (
                                                                <span className="red">
                                                                  (
                                                                  {helpers.currencyFormat(
                                                                    Math.abs(
                                                                      backSubTotalresult.toFixed(2)
                                                                    )
                                                                  )}
                                                                  )
                                                                </span>
                                                              )
                                                            ) : (
                                                              helpers.currencyFormat(
                                                                Math.abs(
                                                                  backSubTotalresult.toFixed(2)
                                                                )
                                                              )
                                                            )}
                                                          </dd>

                                                          <dt id="laySubTotalTitle">
                                                            Lay subtotal
                                                          </dt>
                                                          <dd id="laySubTotal">
                                                            {" "}
                                                            {layTotalProfitAmount >
                                                            layTotalLoseAmount ? (
                                                              helpers.currencyFormat(
                                                                Math.abs(
                                                                  laySubTotalresult.toFixed(2)
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers.currencyFormat(
                                                                  Math.abs(
                                                                    laySubTotalresult.toFixed(2)
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )}
                                                          </dd>
                                                        </>
                                                      )}

                                                      <dt>Market subtotal</dt>

                                                      {betType == "fancy" ? (
                                                        <dd id="marketTotal">
                                                          {yesTotalProfitAmount >
                                                            yesTotalLoseAmount ||
                                                          noTotalProfitAmount >
                                                            noTotalLoseAmount ? (
                                                            helpers.currencyFormat(
                                                              Math.abs(
                                                                fancyMarketSubTotal.toFixed(2)
                                                              )
                                                            )
                                                          ) : (
                                                            <span className="red">
                                                              (
                                                              {helpers.currencyFormat(
                                                                Math.abs(
                                                                  fancyMarketSubTotal.toFixed(2)
                                                                )
                                                              )}
                                                              )
                                                            </span>
                                                          )}
                                                        </dd>
                                                      ) : (
                                                        <>
                                                          <dd id="marketTotal">
                                                            {backTotalProfitAmount >
                                                              backTotalLoseAmount ||
                                                            layTotalProfitAmount >
                                                              layTotalLoseAmount ? (
                                                              helpers.currencyFormat(
                                                                Math.abs(
                                                                  marketSubTotal.toFixed(2)
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers.currencyFormat(
                                                                  Math.abs(
                                                                    marketSubTotal.toFixed(2)
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )}
                                                          </dd>
                                                        </>
                                                      )}
                                                      {betType != "fancy" &&
                                                      betType != "tie" &&
                                                      marketSubTotal > 0 ? (
                                                        <>
                                                          <dt
                                                            id="commissionTitle"
                                                            style={{
                                                              display: "block",
                                                            }}
                                                          >
                                                            Commission
                                                          </dt>
                                                          <dd
                                                            id="commission"
                                                            style={{
                                                              display: "block",
                                                            }}
                                                          >
                                                            {helpers.currencyFormat(
                                                              Math.abs(
                                                                (marketSubTotal *
                                                                  loginUserDetailData.commission) /
                                                                  100
                                                              ).toFixed(2)
                                                            )}
                                                          </dd>
                                                        </>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <dt className="net_total">
                                                        Net Market Total
                                                      </dt>
                                                      {betType == "fancy" ? (
                                                        <dd
                                                          id="netTotal"
                                                          className="net_total"
                                                        >
                                                          {fancyNetAmount >
                                                          0 ? (
                                                            helpers.currencyFormat(
                                                              Math.abs(
                                                                fancyNetAmount.toFixed(2)
                                                              )
                                                            )
                                                          ) : (
                                                            <span className="red">
                                                              (
                                                              {helpers.currencyFormat(
                                                                Math.abs(
                                                                  fancyNetAmount.toFixed(2)
                                                                )
                                                              )}
                                                              )
                                                            </span>
                                                          )}
                                                        </dd>
                                                      ) : (
                                                        <>
                                                          <dd
                                                            id="netTotal"
                                                            className="net_total"
                                                          >
                                                            {netAmount > 0 ? (
                                                              helpers.currencyFormat(
                                                                Math.abs(
                                                                  netAmount.toFixed(2)
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers.currencyFormat(
                                                                  Math.abs(
                                                                    netAmount.toFixed(2)
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )}
                                                          </dd>
                                                        </>
                                                      )}
                                                    </dl>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <img
                                              class="expand-arrow-R"
                                              src={require("../../assets/images/transparent.gif")}
                                            ></img>
                                          </td>
                                        </tr>
                                      )}
                                  </>
                                    
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9" className="text-start">
                                  <span>
                                    You have no bets in this time period.
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}{" "}
                      <p className="table-other">
                        Profit and Loss is shown net of commission.
                      </p>
                    </div>
                    {data?.data?.length > 0 && (
                      // <div className="bottom-pagination">
                      //   <ReactPaginate
                      //     breakLabel="..."
                      //     nextLabel="Next"
                      //     forcePage={viewpage}
                      //     onPageChange={handlePageClick}
                      //     pageRangeDisplayed={10}
                      //     pageCount={pageCount}
                      //     nextLabel="Prev"
                      //     renderOnZeroPageCount={null}
                      //     activeClassName="p-1"
                      //     activeLinkClassName="pagintion-li"
                      //   />
                      // </div>

                      <PaginationComp
                        viewpage={viewpage}
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};
export default ProfitLossHistory;
